import {
  Box,
  Form,
  Icon,
  Text,
  WizardStep,
  WizardStepRenderParams,
  useOnNext,
} from '@factorialco/deprecated-design-system'

import DurationInput from 'modules/core/components/DurationInput'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import {
  ExtraHoursRulesData,
  ExtraHoursRulesDataField,
  validateMandatoryFields,
} from 'modules/attendance/lib/forms/utils/ExtraHourRulesWizardData'

const HourlyRateStep = ({ data, onDataChanged }: WizardStepRenderParams<ExtraHoursRulesData>) => {
  const handleNext = async () => {
    track(trackingEvents.timeTracking.customRuleHourlyRateNextPressed, { isEdit: data.isEdit })

    const mandatoryFields: ExtraHoursRulesDataField[] = ['rawMinutes', 'equivalentMinutes']
    const { invalidFields, dataWithErrors } = validateMandatoryFields(mandatoryFields, data)

    onDataChanged(dataWithErrors)

    if (!!invalidFields.length) {
      return Promise.reject()
    }
  }

  useOnNext(handleNext)

  return (
    <Box flexDirection="row">
      <Box gap="s24">
        <Box gap="s8">
          <Text.Header2 weight="semibold">
            {i18n.t(
              'time_tracking.settings.time_blocks.categories.special_hours.wizard.hourly_rate.title'
            )}
          </Text.Header2>
          <Text.Normal>
            {i18n.t(
              'time_tracking.settings.work_time_categories.extra_hours_rules.new_rule_wizard.tracking_condition.hourly_rate.description'
            )}
          </Text.Normal>
        </Box>
        <Form padding="s0" notRounded>
          <Box flexDirection="row" alignItems="center" justifyContent="spaceEvenly" gap="s8">
            <DurationInput
              label={i18n.t(
                'time_tracking.settings.time_blocks.categories.special_hours.wizard.hourly_rate.worked_time'
              )}
              minutes={data.rawMinutes}
              onChange={(value: number) => onDataChanged({ ...data, rawMinutes: value })}
            />
            <Box paddingTop="s24" alignItems="center" width="fit-content">
              <Icon.Medium icon="arrow-right" />
            </Box>
            <DurationInput
              label={i18n.t(
                'time_tracking.settings.time_blocks.categories.special_hours.wizard.hourly_rate.equals'
              )}
              minutes={data.equivalentMinutes}
              onChange={(value: number) => onDataChanged({ ...data, equivalentMinutes: value })}
            />
          </Box>
        </Form>
      </Box>
    </Box>
  )
}

export const hourlyRateStep = (): WizardStep<ExtraHoursRulesData> => ({
  title: i18n.t(
    'time_tracking.settings.time_blocks.categories.special_hours.wizard.hourly_rate.title'
  ),
  nextText: i18n.t('time_tracking.settings.time_blocks.categories.special_hours.wizard.next'),
  render: (props) => <HourlyRateStep {...props} />,
  isCompleted: (data) => !!data.equivalentMinutes && !!data.rawMinutes,
})
